module.exports = __webpack_public_path__ + "img/132.25a8d271.jpg";